import { useTranslation } from 'react-i18next';
import ServicesSection from '../components/servicesSection/ServicesSection';
import BenefitsSection from '../components/benefitsSection/BenefitsSection';
import HeroProposal from '../components/heroConcept/heroConcept';
import CtaSection from '../components/ctaSection/CtaSection';
import PageSEO from '../components/PageSEO';

const Home = () => {
  const { t } = useTranslation('home');

  const skills = t('services.items', { returnObjects: true }).map((item, i) => ({
    title_skill: item.title,
    descriptions: item.descriptions,
    cta: item.cta,
    link: i === 0 ? '/projects' : i === 1 ? '/design' : '/gallery',
  }));

  return (
    <>
      <PageSEO
        title="PixelCraft — Web Design, Development & Photography"
        description={t('header.text')}
        path="/"
      />
      <HeroProposal />
      <main>
        <ServicesSection skills={skills} />
        <BenefitsSection />
        <CtaSection />
      </main>
    </>
  );
};

export default Home;